import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map';

import { TeInputComponent } from './te-input-component';

/** Input Text Component */

@customElement('te-input-text')
export class TeInputText extends TeInputComponent {
  render() {
    return html`
      <div class="wrapper">
        <div class="te-input" style=${styleMap(this.getWrapperStyle())}>
          ${this.renderLabel()} ${this.renderInput('text')} ${this.renderLoader()}
        </div>
        ${this.renderCharCount()} ${this.renderError()}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'te-input-text': TeInputText;
  }
}
